module.exports = __webpack_public_path__ + "img/prime minister_question.19fdbfc3.png";